<template>
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="disflex" style="justify-content: space-between;">
<!--          <a class="back" href="javascript:void(0)" @click="goBack"  style="margin-left: 20px">-->
<!--            <img width="100" src="../../static/images/back_myid.png" />-->
<!--          </a>-->
          <a  class="logo" @click="getToNav()"><img src="static/images/logo.png" /></a>
          <div class="disflex" style="justify-content: flex-end;">
            <div class="pt-font"><span> <img class="img1" src="../../static/images/hd-ic1.png">{{info.spin_num}}</span></div>
            <div class="pt-font"><span> <img class="img1" src="../../static/images/hd-ic2.png">{{info.book_num}}</span></div>
            <div class="pt-font"><span> <img class="img1" src="../../static/images/hd-ic3.png">{{info.points}}</span></div>
            <!-- <div class="ml10" @click="getLan('language')">
              <img width="40" src="../../static/images/en.png" />
            </div> -->
            <!-- <div class="account-top ar" @click="getAcount()" @click.stop>
              <img width="40" src="static/images/account-icon2.png" v-if="isShow">
              <img width="40" src="static/images/account-icon.png" v-else>
            </div> -->
          </div>
        </div>
        <div class="menu-bg" v-if="isActive">
          <div class="disflex" style="justify-content: space-between;">
            <img width="35" @click="isActive=false" src="../../static/images/back.png" />
          </div>
          <div class="account ac" @click="getMenu('myAccount')">
            <a class="logo" style="margin: -20px auto 0;width: 100px;" @click="getToNav()"><img src="static/images/logo.png" /></a>
            <div class="mt30">
              <img class="account-img" :src="info.avatar" />
            </div>
            <div class="crfff fw7">{{info.nickname}}</div>
          </div>
          <div class="menu-list ac">
            <div class="" :class="{'active':isShowMenu=='RedeemCenter'}" @click="getMenu('RedeemCenter')">{{$t('RedeemCenter')}}</div>
            <div class="" :class="{'active':isShowMenu=='faq'}" @click="getMenu('faq')">{{$t('FAQ')}}</div>
            <div class="" :class="{'active':isShowMenu=='TermsAndCondition'}" @click="getMenu('TermsAndCondition')">{{$t('TC')}}</div>
            <div class="" :class="{'active':isShowMenu=='rankList'}" @click="getMenu('rankList')">{{$t('rankList')}}</div>
            <div class="" :class="{'active':isShowMenu=='redeemList'}" @click="getMenu('redeemList')">{{$t('RedeemList')}}</div>

          </div>
         <!-- <div class="ac">
            <button class="button" style="width: 100%;" @click="unSubscribe">{{$t('logOut')}}</button>
          </div> -->
        </div>
    </div>
    <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
        <div class="alert-modal" style="width: 95%;" slot="mdBox" >
            <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
            <div class="information mt50 crfff ac por">
              <div class="fs50">{{$t('language')}}</div>
              <div class="fs26 mt30 cr0062ff">{{$t('languageTips')}} :</div>
                <div class="change-list change-list2 ac">
                  <div class="one" style="min-height: 255px;" @click="getLang(2,'en')" :class="{'active':isShowLang=='en'}">
                    <img class="dui" src="../../static/images/dui.png">
                    <img style="width:100px" :src="isShowLang=='en'?'../../static/images/en.jpg':'../../static/images/en.jpg'" />
                    <span>{{$t('English')}}</span>
                  </div>
                  <div class="one" style="min-height: 255px;" @click="getLang(2,'bur')" :class="{'active':isShowLang=='bur'}">
                    <img class="dui" src="../../static/images/dui.png">
                    <img style="width:100px" :src="isShowLang=='bur'?'../../static/images/en1.jpg':'../../static/images/en1.jpg'" />
                    <span>{{$t('Myanmar')}}</span>
                  </div>
                </div>
              <div class="ac mt50">
                <button class="button fw7" @click="getLang(1)">{{$t('change')}}</button>
              </div>
            </div>
        </div>
    </Dialog>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
      props: ['message'],
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              info:{},
              isShow:false,
              isActive:false,
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,
              lang:'',
              isShowLang:'bur',
            }
        },
        created(){
          if(localStorage.getItem('lang')){
            this.isShowLang = localStorage.getItem('lang')
          }
          this.getInfo()
        },
		methods: {
      getToNav(){
        this.$router.push({path:'/'});
      },
      getLan(){
        let that = this
        that.$refs.imgDialog.showMaskFun();
      },
      closeTmgDialog(){
        this.$refs.imgDialog.closeMask();
      },

      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          // this.$router.push({path:'/',query:{}});
          location.reload()
        }else{
          this.isShowLang = lang
          this.lang = lang
        }
      },
      getMenu(url){
          this.isShowMenu = url
          let that = this
          setTimeout(function(){
            that.$router.push({path:url,query:{url:url}});
          },500);
      },
			getAcount(){
				let that =this;
			  this.isActive = true;
        this.getInfo()
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	let that =this;
      	that.$parent.$parent.loadModal(true);
      	that.$api.post('api/user/unsub',null,r =>{
      		that.$parent.$parent.returnCode(r,function(){
      	    that.$parent.$parent.loadModal(false);
            that.$utils.alertText(r.msg,80);
      	    localStorage.removeItem('token')
      	    localStorage.removeItem('mobile')
            // that.$router.push({path:'/login'});
            that.$router.push({path:'/'})
      	  });
      	})
      },
      getInfo (){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/info',null,r =>{
        	that.$parent.$parent.returnCode(r,function(){
            that.info = r.data
            localStorage.setItem('info',r.data.score)
            localStorage.setItem('int_url',r.data.invite_url)
            that.$parent.$parent.loadModal(false);
          });
        })
      },
      goBack() {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location.href = "mytel://back";
        }else if (/Android/i.test(navigator.userAgent)) {
          window.location.href = "mytel://back";
        }else{
          window.location.href = "mytel://back";
        }
      }
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue